import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useRoutes, useNavigate, useLocation } from "react-router-dom";

import Router from "./Router";
import {
  baselightTheme,
  basedarkTheme,
  ThemeContext,
} from "./theme/DefaultColors";
import "./App.css";
import { Utills } from "./services/api.services";

function App() {
  Utills.navigate = useNavigate();
  Utills.location = useLocation();
  const routing = useRoutes(Router);
  // const theme = baselightTheme;
  const [mode, setMode] = React.useState("light");
  const switchColorMode = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };
  const theme = React.useMemo(() => {
    return mode === "light" ? baselightTheme : basedarkTheme;
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ switchColorMode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {routing}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default App;
